import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarCheck } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { flattenAgenda, timeLabel } from "@/pages/ProCalendarPage";

export const TodayAppointmentsWidget = () => {
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/me/agenda")
      .then((r) => {
        const today = new Date().toDateString();
        setItems(
          flattenAgenda(r.data || {})
            .filter((e) => e.kind !== "deadline" && e.status !== "cancelled" && e.dt.toDateString() === today)
            .sort((a, b) => a.dt - b.dt),
        );
      })
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <div className="kpi-card mb-6" data-testid="today-appointments">
      <div className="flex items-center gap-3 mb-4">
        <CalendarCheck size={22} color="#4F46E5" />
        <div>
          <div className="label-eyebrow">Calendario</div>
          <h3 className="font-display text-xl font-semibold">Appuntamenti di oggi</h3>
        </div>
      </div>
      <div className="space-y-1">
        {items.map((e) => (
          <button
            key={`${e.kind}-${e.id}`}
            type="button"
            onClick={() => nav("/pro-calendar")}
            className="w-full flex items-center gap-4 p-3 rounded-md text-left hover:bg-[color:hsl(var(--surface-alt))] transition-colors"
            data-testid={`today-appt-${e.id}`}
          >
            <span className="font-mono text-sm font-semibold text-purple-700 w-14 shrink-0" data-testid={`today-appt-time-${e.id}`}>
              {timeLabel(e)}
            </span>
            <span className="flex-1 min-w-0">
              <span className="block text-sm font-medium truncate" data-testid={`today-appt-title-${e.id}`}>{e.title}</span>
              {e.property_name && <span className="block text-xs text-muted-foreground truncate">{e.property_name}</span>}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
